import { EnquiryLifecycleStatusEnum } from "../enum"

export class getAllEnquiryInfoReq{
    tabName:string
    enquiryNo:string
    countryId:number
    destinationId:number
    unitId:number
    status:EnquiryLifecycleStatusEnum
    constructor(
        tabName:string,
        enquiryNo?:string,
        countryId?:number,
        destinationId?:number,
        unitId?:number,
        status?:EnquiryLifecycleStatusEnum
    ){
        this.tabName=tabName
        this.enquiryNo=enquiryNo
        this.countryId=countryId
        this.destinationId=destinationId
        this.unitId=unitId
        this.status=status
    }
}